import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from "./App";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { polyfillCountryFlagEmojis } from "country-flag-emoji-polyfill";
import {Session} from "./auth/session";

const firebaseConfig = {
    apiKey: "AIzaSyCFRKTFsZq_tp3_JRnoIPtsLgEHRy93aoc",
    authDomain: "wayf-re.firebaseapp.com",
    projectId: "wayf-re",
    storageBucket: "wayf-re.firebasestorage.app",
    messagingSenderId: "715195698908",
    appId: "1:715195698908:web:d3083a8f8953743a412e19",
    measurementId: "G-35TT4LP0TX"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

polyfillCountryFlagEmojis();

let session: Session | null = null;
const uid = localStorage.getItem("uid");
const name = localStorage.getItem("name");
const username = localStorage.getItem("username");

if (uid && name) {
    session = {
        uid: uid,
        username: username,
        name: name,
    }
}

root.render(
  <React.StrictMode>
      <App session={session} firebase={app} />
  </React.StrictMode>
);
